"use strict";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _parameters = _interopRequireDefault(require("./parameters"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var isObject = function isObject(v) {
  return typeof v === 'object' && Object.keys(v).length;
};

var isString = function isString(v) {
  return typeof v === 'string' && v.length;
};

var _default = function _default(search, navigate) {
  var params = new _parameters.default(search);

  var redirect = function redirect(prefix) {
    var query = params.redirectStr();
    var path = prefix ? "".concat(prefix).concat(query) : query;
    return navigate(path);
  };

  return {
    params: params,
    redirect: redirect,
    getFrom: function getFrom(key) {
      if (isObject(key)) return params.populate(key);
      if (isString(key)) return params.get(key);
      return null;
    },
    getAll: function getAll() {
      var output = {};

      try {
        // eslint-disable-next-line
        var _iterator = _createForOfIteratorHelper(params.entries()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var pair = _step.value;
            // eslint-disable-next-line
            output[pair[0]] = pair[1];
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      } catch (e) {// noop
      }

      return output;
    },
    pushTo: function pushTo(values) {
      params.merge(values);
      redirect();
      window.scrollTo(0, 0);
    },
    clearByName: function clearByName(next) {
      return function (e) {
        e.stopPropagation();
        params.delete(e.currentTarget.name);
        redirect();
        next();
      };
    },
    handleSearch: function handleSearch(next, redirectPath) {
      return function (_ref) {
        var key = _ref.key,
            target = _ref.target;
        if (key !== 'Enter') return;

        if (!isString(target.value)) {
          params.delete('search');
        } else {
          params.set('search', target.value);
        }

        params.delete('page');
        redirect(redirectPath);
        next();
      };
    }
  };
};

exports.default = _default;